function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "#202020"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.8 21H2.3C1 21 0 20 0 18.7v-6.3c0-1.3 1-2.3 2.3-2.3h1.5c1.3 0 2.3 1 2.3 2.3v6.3c0 1.3-1 2.3-2.3 2.3zM12.8 21h-1.5C10 21 9 20 9 18.7V3C9 1.7 10 .7 11.3.7h1.5C14 .7 15 1.7 15 3v15.7c0 1.3-1 2.3-2.2 2.3zM21.7 21h-1.5c-1.3 0-2.3-1-2.3-2.3V7c0-1.3 1-2.3 2.3-2.3h1.5C23 4.8 24 5.8 24 7v11.7c0 1.3-1 2.3-2.3 2.3z"
}));

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21"
  }, props), _ref);
};

export default SvgComponent;